/**
 * Shared constants for the select-to-chat P2 element inspector
 * (`docs/design/preview-select-to-chat-prd.md`).
 *
 * Lives in the neutral types package because the inspector protocol
 * straddles three contexts that must agree on the marker:
 *   - Electron MAIN builds + injects the inspector script
 *     (`crucible-gui/src/main/preview-inspector-script.ts`).
 *   - The RENDERER parses inspector events + posts commands
 *     (`crucible-ui/src/preview/inspect-protocol.ts`).
 *   - The injected script runs in the preview IFRAME.
 *
 * A single source of truth here stops the marker drifting across the
 * package boundary (main can't import the renderer's DOM-typed
 * modules).
 */
/** postMessage discriminator for every inspector message, distinct
 *  from the construction-event bridge's `__cruciblePreview`. */
export const CRUCIBLE_INSPECT_MARKER = '__crucibleInspect';
/** Descriptor caps the injected inspector applies before a descriptor
 *  crosses the boundary (the self-contained script in
 *  `crucible-ui/src/preview/inspector-script.ts` reads these via its
 *  `cfg`). */
export const INSPECT_DESCRIPTOR_TEXT_CAP = 80;
export const INSPECT_DESCRIPTOR_MAX_CLASSES = 6;
/** Drag distance (px) past which a select-mode gesture is treated as
 *  an area marquee rather than an element click. */
export const INSPECT_DRAG_THRESHOLD = 5;
//# sourceMappingURL=preview-inspect-constants.js.map